import { createStore, applyMiddleware, combineReducers } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { LightTheme, DarkTheme } from "constants/themes";
import themeReducer from "store/reducers/theme.reducer";
import authReducer from "store/reducers/auth.reducer";

const composedEnchancers = composeWithDevTools({ trace: true, traceLimit: 25 });

const persistThemeConfig = {
  key: 'theme',
  version: 1,
  storage,
  migrate: (state: any) => {
    if (!state) return Promise.resolve({
      _persist: { version: 0, rehydrated: false },
      theme: LightTheme,
      fontSize: 'md',
    });

    const mergedState = {
      _persist: { version: 1, rehydrated: true },
      theme: state.theme?.name === "dark" ? { ...DarkTheme, ...state.theme } : { ...LightTheme, ...state.theme },
      fontSize: state.fontSize || 'md',
    };

    return Promise.resolve(mergedState);
  },
};

const persistedThemeReducer: any = persistReducer(
  persistThemeConfig,
  themeReducer
);

const persistAuthConfig = { key: "auth", storage };
const persistedAuthReducer: any = persistReducer(persistAuthConfig, authReducer);

const middlewares =
  process.env.NODE_ENV !== "production"
    ? [require("redux-immutable-state-invariant").default()]
    : [];

const store = createStore(
  combineReducers({
    persistedThemeReducer,
    persistedAuthReducer,
  }),
  {
    persistedThemeReducer: { theme: LightTheme, fontSize: "md" },
    persistedAuthReducer: { user: {}, isLoggedIn: false, uuid: null, token: null },
  },
  composedEnchancers(applyMiddleware(...middlewares))
);

export const persistor = persistStore(store);
export default store;
